const countryFlags = [
  { name: "AF", code: "+93", flagClass: "f16-af" },
  { name: "AL", code: "+355", flagClass: "f16-al" },
  { name: "DZ", code: "+213", flagClass: "f16-dz" },
  { name: "AD", code: "+376", flagClass: "f16-ad" },
  { name: "AO", code: "+244", flagClass: "f16-ao" },
  { name: "AR", code: "+54", flagClass: "f16-ar" },
  { name: "AM", code: "+374", flagClass: "f16-am" },
  { name: "AU", code: "+61", flagClass: "f16-au" },
  { name: "AT", code: "+43", flagClass: "f16-at" },
  { name: "AZ", code: "+994", flagClass: "f16-az" },
  { name: "BS", code: "+1‑242", flagClass: "f16-bs" },
  { name: "BH", code: "+973", flagClass: "f16-bh" },
  { name: "BD", code: "+880", flagClass: "f16-bd" },
  { name: "BB", code: "+1‑246", flagClass: "f16-bb" },
  { name: "BY", code: "+375", flagClass: "f16-by" },
  { name: "BE", code: "+32", flagClass: "f16-be" },
  { name: "BZ", code: "+501", flagClass: "f16-bz" },
  { name: "BJ", code: "+229", flagClass: "f16-bj" },
  { name: "BM", code: "+1‑441", flagClass: "f16-bm" },
  { name: "BT", code: "+975", flagClass: "f16-bt" },
  { name: "BO", code: "+591", flagClass: "f16-bo" },
  { name: "BA", code: "+387", flagClass: "f16-ba" },
  { name: "BW", code: "+267", flagClass: "f16-bw" },
  { name: "BR", code: "+55", flagClass: "f16-br" },
  { name: "BN", code: "+673", flagClass: "f16-bn" },
  { name: "BG", code: "+359", flagClass: "f16-bg" },
  { name: "BF", code: "+226", flagClass: "f16-bf" },
  { name: "BI", code: "+257", flagClass: "f16-bi" },
  { name: "CV", code: "+238", flagClass: "f16-cv" },
  { name: "KH", code: "+855", flagClass: "f16-kh" },
  { name: "CM", code: "+237", flagClass: "f16-cm" },
  { name: "CA", code: "+1", flagClass: "f16-ca" },
  { name: "CF", code: "+236", flagClass: "f16-cf" },
  { name: "TD", code: "+235", flagClass: "f16-td" },
  { name: "CL", code: "+56", flagClass: "f16-cl" },
  { name: "CN", code: "+86", flagClass: "f16-cn" },
  { name: "CO", code: "+57", flagClass: "f16-co" },
  { name: "KM", code: "+269", flagClass: "f16-km" },
  { name: "CG", code: "+242", flagClass: "f16-cg" },
  { name: "CD", code: "+243", flagClass: "f16-cd" },
  { name: "CR", code: "+506", flagClass: "f16-cr" },
  { name: "CI", code: "+225", flagClass: "f16-ci" },
  { name: "HR", code: "+385", flagClass: "f16-hr" },
  { name: "CU", code: "+53", flagClass: "f16-cu" },
  { name: "CY", code: "+357", flagClass: "f16-cy" },
  { name: "CZ", code: "+420", flagClass: "f16-cz" },
  { name: "DK", code: "+45", flagClass: "f16-dk" },
  { name: "DJ", code: "+253", flagClass: "f16-dj" },
  { name: "DM", code: "+1‑767", flagClass: "f16-dm" },
  { name: "DO", code: "+1‑809", flagClass: "f16-do" },
  { name: "EC", code: "+593", flagClass: "f16-ec" },
  { name: "EG", code: "+20", flagClass: "f16-eg" },
  { name: "SV", code: "+503", flagClass: "f16-sv" },
  { name: "GQ", code: "+240", flagClass: "f16-gq" },
  { name: "ER", code: "+291", flagClass: "f16-er" },
  { name: "EE", code: "+372", flagClass: "f16-ee" },
  { name: "ET", code: "+251", flagClass: "f16-et" },
  { name: "FJ", code: "+679", flagClass: "f16-fj" },
  { name: "FI", code: "+358", flagClass: "f16-fi" },
  { name: "FR", code: "+33", flagClass: "f16-fr" },
  { name: "GA", code: "+241", flagClass: "f16-ga" },
  { name: "GM", code: "+220", flagClass: "f16-gm" },
  { name: "GE", code: "+995", flagClass: "f16-ge" },
  { name: "DE", code: "+49", flagClass: "f16-de" },
  { name: "GH", code: "+233", flagClass: "f16-gh" },
  { name: "GR", code: "+30", flagClass: "f16-gr" },
  { name: "GL", code: "+299", flagClass: "f16-gl" },
  { name: "GD", code: "+1‑473", flagClass: "f16-gd" },
  { name: "GU", code: "+1‑671", flagClass: "f16-gu" },
  { name: "GT", code: "+502", flagClass: "f16-gt" },
  { name: "GN", code: "+224", flagClass: "f16-gn" },
  { name: "GW", code: "+245", flagClass: "f16-gw" },
  { name: "GY", code: "+592", flagClass: "f16-gy" },
  { name: "HT", code: "+509", flagClass: "f16-ht" },
  { name: "HN", code: "+504", flagClass: "f16-hn" },
  { name: "HU", code: "+36", flagClass: "f16-hu" },
  { name: "IS", code: "+354", flagClass: "f16-is" },
  { name: "IN", code: "+91", flagClass: "f16-in" },
  { name: "ID", code: "+62", flagClass: "f16-id" },
  { name: "IR", code: "+98", flagClass: "f16-ir" },
  { name: "IQ", code: "+964", flagClass: "f16-iq" },
  { name: "IE", code: "+353", flagClass: "f16-ie" },
  { name: "IL", code: "+972", flagClass: "f16-il" },
  { name: "IT", code: "+39", flagClass: "f16-it" },
  { name: "JM", code: "+1‑876", flagClass: "f16-jm" },
  { name: "JP", code: "+81", flagClass: "f16-jp" },
  { name: "JO", code: "+962", flagClass: "f16-jo" },
  { name: "KZ", code: "+7", flagClass: "f16-kz" },
  { name: "KE", code: "+254", flagClass: "f16-ke" },
  { name: "KI", code: "+686", flagClass: "f16-ki" },
  { name: "KP", code: "+850", flagClass: "f16-kp" },
  { name: "KR", code: "+82", flagClass: "f16-kr" },
  { name: "KW", code: "+965", flagClass: "f16-kw" },
  { name: "KG", code: "+996", flagClass: "f16-kg" },
  { name: "LA", code: "+856", flagClass: "f16-la" },
  { name: "LV", code: "+371", flagClass: "f16-lv" },
  { name: "LB", code: "+961", flagClass: "f16-lb" },
  { name: "LS", code: "+266", flagClass: "f16-ls" },
  { name: "LR", code: "+231", flagClass: "f16-lr" },
  { name: "LY", code: "+218", flagClass: "f16-ly" },
  { name: "LI", code: "+423", flagClass: "f16-li" },
  { name: "LT", code: "+370", flagClass: "f16-lt" },
  { name: "LU", code: "+352", flagClass: "f16-lu" },
  { name: "MG", code: "+261", flagClass: "f16-mg" },
  { name: "MW", code: "+265", flagClass: "f16-mw" },
  { name: "MY", code: "+60", flagClass: "f16-my" },
  { name: "MV", code: "+960", flagClass: "f16-mv" },
  { name: "ML", code: "+223", flagClass: "f16-ml" },
  { name: "MT", code: "+356", flagClass: "f16-mt" },
  { name: "MR", code: "+222", flagClass: "f16-mr" },
  { name: "MU", code: "+230", flagClass: "f16-mu" },
  { name: "MX", code: "+52", flagClass: "f16-mx" },
  { name: "MC", code: "+377", flagClass: "f16-mc" },
  { name: "MN", code: "+976", flagClass: "f16-mn" },
  { name: "ME", code: "+382", flagClass: "f16-me" },
  { name: "MA", code: "+212", flagClass: "f16-ma" },
  { name: "MZ", code: "+258", flagClass: "f16-mz" },
  { name: "MM", code: "+95", flagClass: "f16-mm" },
  { name: "NA", code: "+264", flagClass: "f16-na" },
  { name: "NR", code: "+674", flagClass: "f16-nr" },
  { name: "NP", code: "+977", flagClass: "f16-np" },
  { name: "NL", code: "+31", flagClass: "f16-nl" },
  { name: "NZ", code: "+64", flagClass: "f16-nz" },
  { name: "NI", code: "+505", flagClass: "f16-ni" },
  { name: "NE", code: "+227", flagClass: "f16-ne" },
  { name: "NG", code: "+234", flagClass: "f16-ng" },
  { name: "NO", code: "+47", flagClass: "f16-no" },
  { name: "OM", code: "+968", flagClass: "f16-om" },
  { name: "PK", code: "+92", flagClass: "f16-pk" },
  { name: "PW", code: "+680", flagClass: "f16-pw" },
  { name: "PS", code: "+970", flagClass: "f16-ps" },
  { name: "PA", code: "+507", flagClass: "f16-pa" },
  { name: "PG", code: "+675", flagClass: "f16-pg" },
  { name: "PY", code: "+595", flagClass: "f16-py" },
  { name: "PE", code: "+51", flagClass: "f16-pe" },
  { name: "PH", code: "+63", flagClass: "f16-ph" },
  { name: "PL", code: "+48", flagClass: "f16-pl" },
  { name: "PT", code: "+351", flagClass: "f16-pt" },
  { name: "QA", code: "+974", flagClass: "f16-qa" },
  { name: "RO", code: "+40", flagClass: "f16-ro" },
  { name: "RU", code: "+7", flagClass: "f16-ru" },
  { name: "RW", code: "+250", flagClass: "f16-rw" },
  { name: "KN", code: "+1‑869", flagClass: "f16-kn" },
  { name: "LC", code: "+1‑758", flagClass: "f16-lc" },
  { name: "VC", code: "+1‑784", flagClass: "f16-vc" },
  { name: "WS", code: "+685", flagClass: "f16-ws" },
  { name: "SM", code: "+378", flagClass: "f16-sm" },
  { name: "ST", code: "+239", flagClass: "f16-st" },
  { name: "SA", code: "+966", flagClass: "f16-sa" },
  { name: "SN", code: "+221", flagClass: "f16-sn" },
  { name: "RS", code: "+381", flagClass: "f16-rs" },
  { name: "SC", code: "+248", flagClass: "f16-sc" },
  { name: "SL", code: "+232", flagClass: "f16-sl" },
  { name: "SG", code: "+65", flagClass: "f16-sg" },
  { name: "SK", code: "+421", flagClass: "f16-sk" },
  { name: "SI", code: "+386", flagClass: "f16-si" },
  { name: "SB", code: "+677", flagClass: "f16-sb" },
  { name: "SO", code: "+252", flagClass: "f16-so" },
  { name: "ZA", code: "+27", flagClass: "f16-za" },
  { name: "KR", code: "+82", flagClass: "f16-kr" },
  { name: "SS", code: "+211", flagClass: "f16-ss" },
  { name: "ES", code: "+34", flagClass: "f16-es" },
  { name: "LK", code: "+94", flagClass: "f16-lk" },
  { name: "SD", code: "+249", flagClass: "f16-sd" },
  { name: "SR", code: "+597", flagClass: "f16-sr" },
  { name: "SE", code: "+46", flagClass: "f16-se" },
  { name: "CH", code: "+41", flagClass: "f16-ch" },
  { name: "SY", code: "+963", flagClass: "f16-sy" },
  { name: "TW", code: "+886", flagClass: "f16-tw" },
  { name: "TJ", code: "+992", flagClass: "f16-tj" },
  { name: "TZ", code: "+255", flagClass: "f16-tz" },
  { name: "TH", code: "+66", flagClass: "f16-th" },
  { name: "TL", code: "+670", flagClass: "f16-tl" },
  { name: "TG", code: "+228", flagClass: "f16-tg" },
  { name: "TO", code: "+676", flagClass: "f16-to" },
  { name: "TT", code: "+1‑868", flagClass: "f16-tt" },
  { name: "TN", code: "+216", flagClass: "f16-tn" },
  { name: "TR", code: "+90", flagClass: "f16-tr" },
  { name: "TM", code: "+993", flagClass: "f16-tm" },
  { name: "TV", code: "+688", flagClass: "f16-tv" },
  { name: "UG", code: "+256", flagClass: "f16-ug" },
  { name: "UA", code: "+380", flagClass: "f16-ua" },
  { name: "AE", code: "+971", flagClass: "f16-ae" },
  { name: "GB", code: "+44", flagClass: "f16-gb" },
  { name: "US", code: "+1", flagClass: "f16-us" },
  { name: "UY", code: "+598", flagClass: "f16-uy" },
  { name: "UZ", code: "+998", flagClass: "f16-uz" },
  { name: "VU", code: "+678", flagClass: "f16-vu" },
  { name: "VE", code: "+58", flagClass: "f16-ve" },
  { name: "VN", code: "+84", flagClass: "f16-vn" },
  { name: "YE", code: "+967", flagClass: "f16-ye" },
  { name: "ZM", code: "+260", flagClass: "f16-zm" },
  { name: "ZW", code: "+263", flagClass: "f16-zw" }
];